import React from 'react'
import { createRoot } from 'react-dom/client'
import Cookies from 'js-cookie'

import AlertBanner from '../AlertBanner/AlertBanner.jsx'

class LastLoginElement extends HTMLElement {
  connectedCallback() {
    const reactContainerId = 'last-login-react-app'
    const reactContainer = document.createElement('div')
    reactContainer.setAttribute('id', reactContainerId)
    this.appendChild(reactContainer)

    const userData = {
      name: Cookies.get('CM_INST_FULL_NAME') || '',
      lastLogin: Cookies.get('CM_INST_LASTLOGIN') || '',
    }

    if (userData.name && userData.lastLogin) {
      const container = document.getElementById(reactContainerId)
      const root = createRoot(container)

      root.render(
        <AlertBanner
          status="info"
          sticky={true}
          title={`Welcome, ${userData.name}.`}
          text={`Your last login was ${userData.lastLogin.replaceAll(
            ' , ',
            ', '
          )}`}
          lastLogin={true}
        />
      )
    }
  }
}

customElements.define('last-login', LastLoginElement)
